import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { normalizeURL } from '../helpers/url';

import {
  getPropsConsideringNavigationItemState,
  NAVIGATION_ITEM_STATE,
} from './helpers/navigation-item';

import NavigationItemBackArrow from './navigation-item-back-arrow';
import NavigationItemLabel from './navigation-item-label';
import NavigationItemImage from './navigation-item-image';

import Analytics from '@app/modules/analytics';
import Router from '@app/modules/router';

const NavigationItem = ({
  isActive,
  preventSelfClose,
  path,
  onClick,
  children,
  ...props
}) => {
  const {
    shouldBrowserHandle,
    trackEvent,
    withBackButton,
    hasChannelName,
    name,
    image,
    ...restProps
  } = getPropsConsideringNavigationItemState(
    props,
    isActive ? NAVIGATION_ITEM_STATE.ACTIVE : NAVIGATION_ITEM_STATE.DEFAULT
  );

  const url = normalizeURL(path, restProps.queryParams, restProps.fragment);

  const onLinkClick = (event) => {
    if (shouldBrowserHandle) {
      return;
    }

    event.preventDefault();

    if (isActive) {
      if (!preventSelfClose) {
        setTimeout(Router.navigateTo, 0, Router.getLastRoute('transfer', '/'));
      }
    } else if (trackEvent.category && trackEvent.action) {
      Analytics.trackSnowplowEvent({
        category: trackEvent.category,
        action: trackEvent.action,
        label: trackEvent.label, //optional
      });
    }

    onClick();
  };

  return (
    <React.Fragment>
      <a href={url} onClick={onLinkClick} className="nav__link">
        {withBackButton && <NavigationItemBackArrow />}
        <NavigationItemLabel hasChannelName={hasChannelName}>
          {name}
        </NavigationItemLabel>
        <NavigationItemImage url={image} />
      </a>
      {children}
    </React.Fragment>
  );
};

NavigationItem.propTypes = {
  isActive: PropTypes.bool.isRequired,
  preventSelfClose: PropTypes.bool,
  path: PropTypes.string,
  queryParams: PropTypes.objectOf(PropTypes.string),
  fragment: PropTypes.string,
  shouldBrowserHandle: PropTypes.bool,
  hasChannelName: PropTypes.bool,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  withBackButton: PropTypes.bool,
  image: PropTypes.string,
  trackEvent: PropTypes.shape({
    category: PropTypes.string,
    action: PropTypes.string,
    label: PropTypes.string,
  }),

  onClick: PropTypes.func,
};

NavigationItem.defaultProps = {
  trackEvent: {},

  onClick: noop,
};

export default React.memo(NavigationItem);
